export interface RegistrationDomainRestrictionError {
  message: string;
  allowedDomains: string[];
}

interface RegistrationDomainRestrictionDetail {
  message?: unknown;
  allowed_domains?: unknown;
}

function isPlainObject(value: unknown): value is Record<string, unknown> {
  return value !== null && typeof value === "object" && !Array.isArray(value);
}

export function parseRegistrationDomainRestrictionError(
  error: unknown,
): RegistrationDomainRestrictionError | null {
  if (!error || typeof error !== "object") return null;

  const fetchError = error as { status?: number; data?: { detail?: unknown } };
  if (fetchError.status !== 400 || !fetchError.data) return null;

  const detail = fetchError.data.detail;
  if (!isPlainObject(detail)) return null;

  const { message, allowed_domains } = detail as RegistrationDomainRestrictionDetail;
  if (typeof message !== "string" || !message.trim()) return null;
  if (!Array.isArray(allowed_domains)) return null;

  const allowedDomains = allowed_domains.filter(
    (domain): domain is string => typeof domain === "string" && domain.length > 0,
  );

  return {
    message: message.trim(),
    allowedDomains,
  };
}
